<template>
  <div class="flex flex-col gap-3">
    <div class="flex flex-wrap gap-x-0.5 gap-y-1">
      <div v-for="category in categories" :key="category.id">
        <div
          v-if="spot.categories.map((cat: Category) => cat.id).indexOf(category.id) < 0"
        >
          <input
            type="checkbox"
            class="peer appearance-none"
            :id="category.id.toString()"
            :value="category.id"
            v-model="selectedCategories"
          />
          <label
            :for="category.id.toString()"
            class="peer-checked:bg-theme-primary peer-checked:shadow-none transition-all duration-75 shadow-md cursor-pointer px-1 py-[2px] bg-white uppercase text-black border-theme-primary border-solid border-[1px] rounded-[20px] text-[14px]"
            >{{ category.name }}</label
          >
        </div>
      </div>
    </div>
    <ButtonSubmit
      :loading="uploading"
      :error="error"
      @click="addCategories"
      :disable-submit="selectedCategories.length < 1"
    />
  </div>
</template>
<script setup lang="ts">

const props = defineProps<{ spot: SpotDetail }>()

const emit = defineEmits(["success"]);

const selectedCategories = ref<Array<number>>([]);
const uploading = ref<boolean>();
const error = ref<boolean>(false);
const { t } = useI18n();

const {data: categories, error: categoriesError} = await useApi().asyncData<Array<Category>>("categories");

function reset() {
  selectedCategories.value = [];
  error.value = false;
}

function addCategories() {
  error.value = false;
  uploading.value = true;

  const formData = new FormData();
  selectedCategories.value.forEach((id) => {
    formData.append("categoryIds[]", id.toString());
  });

  useApiAuth().post<Array<number>>("spots/" + props.spot.id + "/categories", formData)
    .then((addedIds) => {
      const addedCategories = categories.value ? categories.value.filter((cat) =>
        addedIds.includes(cat.id)
      ) : [];
      props.spot.categories.push(...addedCategories);
      reset();
      emit("success");
    })
    .catch((theError) => {
      error.value = true;
    }).finally(() => {
      uploading.value = false;
    })

}
</script>
